import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatDrawer} from "@angular/material/sidenav";
import {SidebarService} from "./services/sidebar.service";
import {Title} from "@angular/platform-browser";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {catchError, EMPTY, filter} from "rxjs";
import {map} from "rxjs/operators";
import {UtilService} from "./services/util.service";
import {HttpHeaders} from "@angular/common/http";
import {User} from "./models/user";
import {HttpService} from "./services/http.service";
import {StateService} from "./services/state.service";
import {NavType} from "./models/nav-menu";


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit{
  title = 'EPDS';
  firstLoad = true;

  @ViewChild('drawer') public drawer!: MatDrawer;

  constructor(private router : Router,
              private activatedRoute: ActivatedRoute,
              private titleService : Title,
              public sidebarService:SidebarService,
              private util : UtilService,
              private httpService : HttpService,
              public stateService : StateService) {
    this.stateService.configureIdleKeepalive();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child) {
          if (child.firstChild) {
            child = child.firstChild;
          } else if (child.snapshot.data) {
            return child.snapshot.data;
          } else {
            return null;
          }
        }
        return null;
      })
    ).subscribe( (data: any) => {
      if (data) {
        if (!util.skipLinkPath || this.router.url === "/" || util.skipLinkPath.indexOf(this.router.url) == -1 ||
          this.router.url == "/admin/dashboard") {
          util.skipLinkPath = `${this.router.url}#mainContent`;
        }
        // NVDA is double announcing on initial page load...
        // also announces after the autofocus controls...
        this.titleService.setTitle(data.title + ' | EPDS');
        if (this.firstLoad) {
          this.firstLoad = false;
        } else {
          util.liveAnnounce(data.title + ' | EPDS', 'assertive');
        }

        // set sidebar navigation type (user role already in stateService from login)
        if (data.navType) {
          this.sidebarService.navType = data.navType;
        } else {
          this.sidebarService.navType = NavType.NONE;
        }

        if (data.dashType) {
          this.stateService.dashType = data.dashType;
        }

        // general non-profileInfo specific call
        this.sidebarService.setNavByUser(this.stateService.user.role_id);
        document.getElementById("mainContent")?.scrollIntoView();
      }
    });
  }

  ngOnInit() {
    this.stateService.checkLoginValid();
  }

  ngAfterViewInit(): void {
    this.sidebarService.setDrawer(this.drawer);

    if (navigator.clipboard) {
      this.util.haveClipboard = true;
    }
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

}
